import React from 'react';
import { useTranslator } from 'tradera/lang/translate';
import Flag from 'tradera/components/flag/flag';
import styles from './select-country.module.scss';
import { mapCountryCodeToCountryKey } from 'tradera/localization/countries';
import { classNames } from 'tradera/utils/class-names';
import { HorizontalSeparator } from 'tradera/components/separator/separator';

export const SelectCountry = ({
    availableCountries,
    selectedCountryCodeIso2,
    onCountrySelected,
    className
}) => {
    const { t } = useTranslator();

    const filteredCountries = availableCountries.filter(
        ({ code }) => code !== selectedCountryCodeIso2
    );
    const onChange = (selectedValue) => {
        if (selectedValue.length !== 2) {
            return;
        }

        onCountrySelected(selectedValue);
    };

    return (
        <>
            <HorizontalSeparator className="text-gray-400" />
            <div className={classNames('d-flex align-items-center', className)}>
                <Flag
                    countryCodeIso2={selectedCountryCodeIso2}
                    className="icon icon-sm mx-1"
                />
                <select
                    className={classNames(
                        'no-border form-control pl-1 pr-5 single-select d-inline-block',
                        styles.countrySelect
                    )}
                    onChange={(e) => onChange(e.target.value)}>
                    <option value="" key="Selected value">
                        {selectedCountryCodeIso2
                            ? t(
                                  mapCountryCodeToCountryKey(
                                      selectedCountryCodeIso2
                                  )
                              )
                            : '---'}
                    </option>
                    {filteredCountries.map((item, index) => (
                        <option value={item.code} key={`${item.code}-${index}`}>
                            {item.name}
                        </option>
                    ))}
                </select>
            </div>
        </>
    );
};
